var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"serverfade","mode":"out-in"},on:{"after-enter":function($event){return _vm.animationEnterDone()}}},[(!_vm.page)?_c('div',{attrs:{"data-server-content":""}},[_vm._t("default")],2):_vm._e(),_c(_vm.page,{tag:"component",attrs:{"data-server-content":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }